const ACTION_LABELS: Record<string, string> = {
  CREATE_CATEGORY: 'Category created',
  UPDATE_CATEGORY: 'Category updated',
  ENABLE_CATEGORY: 'Category enabled',
  DISABLE_CATEGORY: 'Category disabled',
  UPDATE_CATEGORY_LOCALE: 'Category locale updated',
  CATEGORY_REORDERED: 'Category order updated',
};

export const auditActionToLabel = (
  action: string | null | undefined,
): string => {
  if (!action) return 'Unknown event';
  return ACTION_LABELS[action] ?? 'Unknown event';
};
